import { DataGrid } from "devextreme-react";
import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";

import logoH2Img from "./hBeccoCRO.png";

import { Column, LoadPanel, StateStoring } from "devextreme-react/data-grid";

export default function QR() {
  const { type, SEQ } = useParams();
  // const [data, setData] = useState(null);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    // axios
    //   .get(`${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt/${type}/${SEQ}`)
    //   .then((result) => {
    //     setData(result.data);
    //   });

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr/simple/${type}/${SEQ}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, []);

  return (
    <React.Fragment>
      <div>
        <img
          src={logoH2Img}
          width="200"
          height="70"
          alt="common_logo_black"
          style={{
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        />
      </div>

      <DataGrid
        id="QR-EqptArr"
        keyExpr="name"
        dataSource={dataSource}
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
      >
        <LoadPanel enabled={true} />

        {/* <FilterRow visible={true} /> */}
        {/* <HeaderFilter visible={true} /> */}

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"EquipmentManagement.QR"}
        />

        <Column dataField="type" caption="분류" alignment="center" />
        <Column dataField="name" caption="성명" alignment="center" />
        <Column dataField="mob" caption="연락처" alignment="center" />
      </DataGrid>
      <div>* 제품을 습득하신 경우 위의 번호로 연락 바랍니다.</div>
    </React.Fragment>

    // <React.Fragment>
    //   { <h1
    //     style={{
    //       color: "#1B4452",
    //       marginBlockStart: "0.67em",
    //       marginBlockEnd: "0.67em",
    //       marginInlineStart: "0px",
    //       marginInlineEnd: "0px",
    //     }}
    //   >
    //     장비정보
    //   </h1>
    //   <Form
    //     id="form-eqptMgmt-QR"
    //     // ref={formRef}
    //     formData={data}
    //     labelMode={"outside"}
    //     showColonAfterLabel={false}
    //     labelLocation={"top"}
    //     // minColWidth={300}
    //     validationGroup="eqptMgmt-moreInfo"
    //     colCount={2}
    //     colCountByScreen={{
    //       sm: 2,
    //       md: 4,
    //     }}
    //     screenByWidth={(width) => {
    //       return width < 720 ? "sm" : "md";
    //     }}
    //   >
    //     <SimpleItem
    //       dataField="codeNo"
    //       editorType="dxTextBox"
    //       editorOptions={{ readOnly: true }}
    //     >
    //       <Label text="Code No." />
    //     </SimpleItem>
    //     <SimpleItem
    //       dataField="typeName"
    //       editorType="dxTextBox"
    //       editorOptions={{ readOnly: true }}
    //     >
    //       <Label text="유형" />
    //     </SimpleItem>
    //     <SimpleItem
    //       dataField="yrMthOfMfg"
    //       editorType="dxDateBox"
    //       editorOptions={{ readOnly: true, displayFormat: "yyyy-MM-dd" }}
    //     >
    //       <Label text="제조년월" />
    //     </SimpleItem>
    //     <SimpleItem
    //       dataField="mfgCo"
    //       editorType="dxTextBox"
    //       editorOptions={{ readOnly: true }}
    //     >
    //       <Label text="제조사" />
    //     </SimpleItem>
    //     <SimpleItem
    //       dataField="mName"
    //       editorType="dxTextBox"
    //       editorOptions={{ readOnly: true }}
    //     >
    //       <Label text="모델명" />
    //     </SimpleItem>
    //     {type == "1" && (
    //       <SimpleItem
    //         dataField="cpu"
    //         editorType="dxTextBox"
    //         editorOptions={{ readOnly: true }}
    //       >
    //         <Label text="CPU" />
    //       </SimpleItem>
    //     )}
    //     {type == "1" && (
    //       <SimpleItem
    //         dataField="memory"
    //         editorType="dxTextBox"
    //         editorOptions={{ readOnly: true }}
    //       >
    //         <Label text="Memory" />
    //       </SimpleItem>
    //     )}
    //     {type == "1" && (
    //       <SimpleItem
    //         dataField="stgeCap"
    //         editorType="dxTextBox"
    //         editorOptions={{ readOnly: true }}
    //       >
    //         <Label text="Storage Capacity" />
    //       </SimpleItem>
    //     )}
    //     {type == "2" && (
    //       <SimpleItem
    //         dataField="inch"
    //         editorType="dxTextBox"
    //         editorOptions={{ readOnly: true }}
    //       >
    //         <Label text="Inch" />
    //       </SimpleItem>
    //     )}
    //   </Form>
    //   <h1
    //     style={{
    //       color: "#1B4452",
    //       marginBlockStart: "0.67em",
    //       marginBlockEnd: "0.67em",
    //       marginInlineStart: "0px",
    //       marginInlineEnd: "0px",
    //     }}
    //   >
    //     배치정보
    //   </h1>
    //   <DataGrid
    //     id="QR-EqptArr"
    //     keyExpr="id"
    //     dataSource={dataSource}
    //     rowAlternationEnabled={true}
    //     showBorders={true}
    //     showColumnLines={true}
    //     focusedRowEnabled={true}
    //     allowColumnResizing={true}
    //     columnAutoWidth={true}
    //   >
    //     <LoadPanel enabled={true} />

    //     <FilterRow visible={true} />
    //     <HeaderFilter visible={true} />

    //     {type == "1" && (
    //       <Column dataField="name" caption="임직원명">
    //       </Column>
    //     )}
    //     {type == "2" && (
    //       <Column dataField="loc" caption="위치">
    //       </Column>
    //     )}
    //     <Column
    //       dataField="asgmtDate"
    //       caption="배치일자"
    //       dataType="date"
    //       format="yyyy-MM-dd"
    //       editorOptions={{
    //         dateSerializationFormat: "yyyy-MM-dd",
    //       }}
    //     />
    //     <Column
    //       dataField="unasgmtDate"
    //       caption="회수일자"
    //       dataType="date"
    //       format="yyyy-MM-dd"
    //       editorOptions={{
    //         dateSerializationFormat: "yyyy-MM-dd",
    //       }}
    //     />
    //   </DataGrid> }
    // </React.Fragment>
  );
}
